module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/people_a2-92fb7bea40ae87e28f5a0990d1e8a771.svg";